import { SEARCH_RESULTS_INBOUND_ROUTE_PATH, SEARCH_RESULTS_OUTBOUND_ROUTE_PATH } from "@flights/constants";
import { matchPath } from "react-router-dom";

const useGetSearchResultsBound = () => {
  const isOutbound = !!matchPath(window.location.pathname, { path: SEARCH_RESULTS_OUTBOUND_ROUTE_PATH });
  const isInbound = !!matchPath(window.location.pathname, { path: SEARCH_RESULTS_INBOUND_ROUTE_PATH });

  return isOutbound ? "outbound" : isInbound ? "inbound" : null;
};

export default useGetSearchResultsBound;
